import { css } from "@emotion/react";
import { Box, Grid } from "@mui/material";
import { BackgroundColor } from "@unit/styles";
import { useAtom } from "jotai";
import Head from "next/head";
import React from "react";
import { ToastContainer } from "react-toastify";

import InitialFadeOutTitlesProvider from "@/components/common/InitialFadeOutTitles";
import HomeNavFooter from "@/components/layout/footer/HomeNavFooter";
import BackdropProgress from "@/components/provider/BackdropProgress";
import GlobalDialogProvider from "@/components/provider/GlobalDialogProvider";
import GlobalJotaiProvider from "@/components/provider/GlobalJotaiProvider";
import { initializingAtom, selectInfluencerTicketIdAtom } from "@/global-state/jotai-atom";

type Props = {
  noHeader?: boolean;
  children: React.ReactNode;
};

const Layout: React.FC<Props> = (props) => {
  const [initializing] = useAtom(initializingAtom);
  const [myTicketId] = useAtom(selectInfluencerTicketIdAtom);

  const hasNavFooter = !myTicketId.chatOpen;

  if (initializing) {
    return (
      <BackdropProgress open={true}>
        <InitialFadeOutTitlesProvider />
      </BackdropProgress>
    );
  }

  return (
    <BackdropProgress>
      <GlobalJotaiProvider>
        <GlobalDialogProvider>
          <Head>
            <title>ユニット</title>
            <meta name="description" content="ユニット" />
            <link rel="icon" href="/favicon.ico" />
          </Head>
          {props.noHeader ? (
            <Box css={style.noHeader}>{props.children}</Box>
          ) : (
            <Box position="relative" css={style.hasHeader}>
              {props.children}

              {/* MEMO: チャット機能のページではHomeNavFooterの位置にチャット送信用コンポーネントを表示 */}
              {hasNavFooter && (
                <Grid py={2} css={style.stickyItem}>
                  <HomeNavFooter />
                </Grid>
              )}
            </Box>
          )}
          <ToastContainer position="top-right" theme="colored" />
        </GlobalDialogProvider>
      </GlobalJotaiProvider>
    </BackdropProgress>
  );
};

export default Layout;

const style = {
  noHeader: css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    height: 100%;
    max-width: 768px !important;
    margin: auto;
    background: ${BackgroundColor.lightBasic};
  `,
  hasHeader: css`
    max-width: 768px !important;
    min-height: 100vh;
    margin: auto;
    padding-bottom: 80px;
    background: ${BackgroundColor.none};
  `,
  stickyItem: css`
    z-index: 800;
    position: fixed;
    bottom: 0;
    width: 100%;
    max-width: 768px;
    height: 80px;
    background: ${BackgroundColor.lightBasic};
  `,
};
